module.exports = __webpack_public_path__ + "img/pzlx1@3x.76ebbcac.png";